import React from 'react';
import PropTypes from "prop-types";
import {LoadingOverlay} from "../LoadingOverlay";

import {useMediaQuery, useTheme} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Slide from "@mui/material/Slide";

import CloseIcon from '@mui/icons-material/Close';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const DEFAULT_APPLY_LABEL = "Applica";
const DEFAULT_CLOSE_LABEL = "Cancella";
const DEFAULT_MAX_WITDH = "sm";


const ResponsiveDialog = props => {
    const {
        title,
        isOpen,
        maxWidth,
        scroll,
        isLoading,
        showApply,
        applyLabel,
        enableApply,
        onApply,
        closeLabel,
        onClose,
        children,
        disableBackdropClose
    } = props;

    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

    const computedMaxWidth = maxWidth || DEFAULT_MAX_WITDH;
    const computedScroll = scroll || 'paper';
    const computedEnableApply = enableApply !== false;
    const computedApplyLabel = applyLabel || DEFAULT_APPLY_LABEL;
    const computedCloseLabel = closeLabel || DEFAULT_CLOSE_LABEL;

    const handleClose = (object, reason) => {
        if (disableBackdropClose && reason === "backdropClick") {
            return;
        }

        onClose();
    };

    return (
        <Dialog
            fullScreen={fullScreen}
            fullWidth={true}
            maxWidth={computedMaxWidth}
            scroll={computedScroll}
            TransitionComponent={Transition}
            open={isOpen}
            onClose={handleClose}
            aria-labelledby={typeof title === 'string' ? title : "dialog-title" }>

            {fullScreen ? (
                <AppBar position="relative" sx={{mb: 3}}>
                    <Toolbar>
                        <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
                            <CloseIcon/>
                        </IconButton>
                        <Typography variant="h6" sx={{ml: 2, flexGrow: 1}}>
                            {title}
                        </Typography>
                        {
                            showApply &&
                            <Button autoFocus color="inherit" disabled={!computedEnableApply} onClick={onApply}>
                                {computedApplyLabel}
                            </Button>
                        }
                    </Toolbar>
                </AppBar>
            ) : (
                <DialogTitle>{title}</DialogTitle>
            )
            }

            <DialogContent>
                {children}
            </DialogContent>

            {!fullScreen &&
            <DialogActions sx={{py: 2, px: 3}}>
                <Button color="primary"
                        variant={showApply ? "text" : "contained"}
                        onClick={handleClose}>
                    {computedCloseLabel}
                </Button>
                {
                    showApply &&
                    <Button disabled={!computedEnableApply}
                            variant="contained"
                            onClick={onApply}>
                        {computedApplyLabel}
                    </Button>
                }
            </DialogActions>
            }
            <LoadingOverlay isLoading={!!isLoading}/>
        </Dialog>
    );
};

ResponsiveDialog.propTypes = {
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
    isOpen: PropTypes.bool.isRequired,
    maxWidth: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
    scroll: PropTypes.oneOf(['body', 'paper']),
    isLoading: PropTypes.bool,
    showApply: PropTypes.bool,
    applyLabel: PropTypes.string,
    enableApply: PropTypes.bool,
    onApply: PropTypes.func,
    closeLabel: PropTypes.string,
    onClose: PropTypes.func.isRequired,
    children: PropTypes.node.isRequired,
    disableBackdropClose: PropTypes.bool,
};

export {ResponsiveDialog}
